import {
    HttpResponse,
    QueryModel,
    RequestParams,
    ApiResultFailed,
    Operation,
    FullRequestParams,
    TenantUserModel,
    AggregationModel,
    AggregationResponse,
    GrouppedQueryModel
} from "@/libs/Api";
import ApiService from "@/libs/core/api-service"
import {CrudDataQuery, CrudService} from '@/libs/core/+state/models/crud-service';
import {CrudEnumerableResponse, CrudResponse} from "../core/+state/models/crud-response";

export class TenantConnectionsDataService implements CrudService<TenantUserModel, TenantUserModel> {
    getAll(query: CrudDataQuery<TenantUserModel>): Promise<CrudEnumerableResponse<TenantUserModel>> {
        return ApiService.api.getTenantConnectionBatch(query.pageIndex, query.pageSize, <any>query.data, query.params);
    }

    getBasicAll(query: CrudDataQuery<TenantUserModel>): Promise<CrudEnumerableResponse<TenantUserModel>> {
        throw new Error('NotImplemented');
    }

    get(id: string, params?: RequestParams): Promise<CrudResponse<TenantUserModel>> {
        throw new Error('NotImplemented');
    }

    create(item: TenantUserModel, params?: RequestParams): Promise<CrudResponse<TenantUserModel>> {
        return ApiService.api.insertTenantConnection(item, params);
    }

    update(item: TenantUserModel, params?: RequestParams): Promise<TenantUserModel> {
        throw new Error('NotImplemented');
    }

    partialUpdate(id: string, patches: Operation[], params?: RequestParams): Promise<TenantUserModel> {
        throw new Error('NotImplemented');
    }

    delete(query: CrudDataQuery<TenantUserModel>): Promise<CrudEnumerableResponse<TenantUserModel>> {
        return ApiService.api.deleteTenantConnection(<any>query.data, query.params).then((req: any) => req.data.returnValue);
    }

    getAggregation(query: AggregationModel, params?: RequestParams): Promise<AggregationResponse> {
        throw new Error('NotImplemented');
    }
    
    download(query: CrudDataQuery<TenantUserModel>): Promise<HttpResponse<any, ApiResultFailed | void>> {
        throw new Error('NotImplemented');
    }

    clone(item: TenantUserModel, params?: RequestParams): Promise<CrudResponse<TenantUserModel>> {
        throw new Error('NotImplemented');
    }

    getGroupped(query: GrouppedQueryModel, params?: RequestParams): Promise<CrudResponse<any>> {
        throw new Error('NotImplemented');
    }

}
